import { useState } from 'react';
import { 
  Fab, 
  SpeedDial, 
  SpeedDialAction, 
  SpeedDialIcon,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { 
  Home as HomeIcon,
  Add as AddIcon,
  List as ListIcon,
  AdsClick as AdsClick
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function FloatingMenu() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const actions = [
    { icon: <HomeIcon />, name: 'Início', action: () => navigate('/') },
    { icon: <AddIcon />, name: 'Novo Aviso', action: () => navigate('/avisos/novo') },
    { icon: <ListIcon />, name: 'Avisos', action: () => navigate('/avisos') },
    { icon: <AdsClick />, name: 'Apresentar', action: () => navigate('/exibir') },
  ];

  if (!isMobile) return null;

  return (
    <SpeedDial
      ariaLabel="Menu de navegação"
      sx={{ position: 'fixed', bottom: 16, right: 16 }}
      icon={<SpeedDialIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={() => {
            action.action();
            handleClose();
          }}
        />
      ))}
    </SpeedDial>
  );
}

export default FloatingMenu; 